export default function Machines_A_10 (number = 1) {
  return {
    name: '能量枢纽',
    icon: '/static/img/machines/a10.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_10.js